/**
 * Vocabulary basis for customer-facing Scan Report / signed-record nouns.
 *
 * Changing report nouns is a basis change (Phase 0 locked): note + date on new
 * chrome; do not retrofit already-signed revision payloads.
 *
 * Canonical chain:
 * Recurring pattern → Safety Case → Baseline → Control → Recheck → Verified result
 */
export const REPORT_VOCABULARY_BASIS = {
  effectiveDate: '2026-08-04',
  shortNote: 'Vocabulary basis · 2026-08-04',
  detail:
    'Customer vocabulary basis effective 2026-08-04: Recurring pattern → Safety Case → Baseline → Control → Recheck → Verified result. Prior signed revisions are not retrofitted.',
} as const;
